import auth1 from "../assets/pictures/home/auth1.jpg";
import p1 from "../assets/pictures/home/Kashmir.webp";
import { cls } from "../components/Utility";
import logo from "../assets/logos/RG copy 2.png";
import p2 from "../assets/pictures/home/P-H1.webp";
import p3 from "../assets/pictures/home/Untitled-2 (2).webp";
import p4 from "../assets/pictures/home/H-P2.webp";
import p5 from "../assets/pictures/home/photography66.webp";
import p6 from "../assets/pictures/home/photography77.webp";
import p7 from "../assets/pictures/home/P-H.webp";
import p8 from "../assets/pictures/home/AKR02670 copy.webp";
import p9 from "../assets/pictures/home/photography12.webp";
import DesktopWa from "../components/DesktopWa";
import Call from "../components/Call";

export default function Photography() {
  return (
    <>
      <div className={cls("hidden", "xl:flex")}>
        <div className="relative w-full h-screen overflow-hidden">
          <div className="w-full h-full">
            <img src={p3} />
          </div>
          <div className="absolute inset-x-0 bottom-[60px] flex items-center justify-center">
            <div className="text-center text-white font-[Headings]">
              <h1 className="text-[25px] font-semibold tracking-widest fadeInUp ">
                LOVE X EMOTION x SOUL
              </h1>
            </div>
          </div>
        </div>
      </div>

      <div className={cls("flex overflow-x-hidden", "xl:hidden")}>
        <div className="relative w-full overflow-hidden">
          <img src={p3} className="w-full h-[500px] object-cover" />

          <div className="absolute inset-x-0 top-[420px] flex items-center justify-center">
            <div className="text-center text-white font-[Headings]">
              <h1 className="text-[20px] font-semibold tracking-widest fadeInUp ">
                LOVE X EMOTION x SOUL
              </h1>
            </div>
          </div>
        </div>
      </div>

      <div
        className={cls(
          "flex flex-col gap-[10px] mt-[20px] pl-[20px] pr-[20px]",
          "xl:flex xl:flex-row xl:gap-[10px] xl:mt-[40px] xl:justify-center"
        )}
      >
        <img
          src={p6}
          className={cls(
            "w-full h-[350px] object-cover",
            "xl:w-[600px] xl:h-[700px] xl:object-cover"
          )}
        />

        <img
          src={p5}
          className={cls(
            "w-full h-[350px] object-cover",
            "xl:w-[600px] xl:h-[700px] xl:object-cover"
          )}
        />
      </div>
      <p
        className={cls(
          "pl-[20px] pr-[20px] text-[14px] font-[description1] mt-[40px] text-center",
          "xl:pl-[380px] xl:pr-[380px]"
        )}
      >
        Soul and love are the essence of every beautiful story. When two hearts
        connect, it's more than just a moment. It's a feeling that echoes
        through time. We capture that soulful love, the kind that speaks without
        words and lives on in every frame.
      </p>
      <div className="flex justify-center mb-[20px]">
        <img src={logo} className="w-[70px] h-[70px] object-contain" />
      </div>

      <div
        className={cls(
          "flex flex-col gap-[10px] pl-[20px] pr-[20px] mb-[40px]",
          "xl:flex xl:flex-row xl:gap-[5px] xl:justify-center"
        )}
      >
        <img
          src={p2}
          className={cls(
            "w-full h-[400px] object-cover",
            "xl:w-[350px] xl:h-[450px] xl:object-cover"
          )}
        />
        <img
          src={p7}
          className={cls(
            "w-full h-[400px] object-cover",
            "xl:w-[350px] xl:h-[450px] xl:object-cover"
          )}
        />
        <img
          src={p4}
          className={cls(
            "w-full h-[400px] object-cover",
            "xl:w-[350px] xl:h-[450px] xl:object-cover"
          )}
        />
      </div>

      <p className="mt-[20px] mb-[20px] font-[Headings] text-[20px] tracking-widest text-[#7F461B] text-center">
        THE BEST MOMENTS IN LIFE SHOULD MAKE YOU BLUSH
      </p>

      <p
        className={cls(
          "pl-[20px] pr-[20px] text-[14px] font-[description1] mb-[40px] text-center",
          "xl:pl-[380px] xl:pr-[380px]"
        )}
      >
        The best moments in life are the ones that catch you off guard, a shy
        smile, a stolen glance, a heartfelt laugh that lingers. They make your
        cheeks flush with joy, reminding you that magic lives in the simplest,
        most genuine emotions.
      </p>
      <div
        className={cls(
          "flex flex-col justify-center items-center pl-[20px] pr-[20px] xl:pl-0 xl:pr-0 gap-[10px] mb-[20px]"
        )}
      >
        <img
          src={p8}
          className="w-full h-[600px] object-cover xl:w-[600px] xl:h-[800px]"
        />
        <img
          src={p9}
          className="w-full h-[600px] object-cover xl:w-[600px] xl:h-[800px]"
        />
      </div>

      <img
        src={p1}
        className="w-full xl:h-[700px] xl:object-cover h-full object-contain mb-[30px]"
      />

      <p
        className={cls(
          "pl-[20px] pr-[20px] text-[14px] font-[description1] text-center",
          "xl:pl-[380px] xl:pr-[380px]"
        )}
      >
        Through our lens, we don't just capture faces; we capture the heartbeat
        of a feeling, the soul of a connection. Because the truest stories are
        the ones told through the eyes, the touch, and the unspoken in-between.
      </p>
      <div className="flex justify-center mb-[10px]">
        <img src={logo} className="w-[70px] h-[70px] object-contain" />
      </div>
      <div className="chat-icon">
        <DesktopWa />
      </div>
      <div className="chat-icon1">
        <Call phoneNumber="9353624245" />
      </div>
    </>
  );
}
